import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    RpReportAgentFavoriteComponent
} from "../component/protected-components/rp-report-agent-favorite/rp-report-agent-favorite.component";
import {RpReportComponent} from "../component/protected-components/rp-report-component/rp-report.component";
import {RpConfigPage} from "../page/overview/config/rp-config.page";
import {RpReportPage} from "../page/report-page/rp-report.page";

const rpModuleEntry: TestModuleDefinition = {
    key: 'rp',
    label: 'Reports (rp)',
    components: [
        {
            key: 'rpReportAgentFavoriteComponent',
            component: RpReportAgentFavoriteComponent,
            selector: 'rp-report-agent-favorite-component',
            type: 'ObjectBaseComponent',
            label: 'Report Agent Favorite Component'
        },
        {
            key: 'RpReportComponent',
            component: RpReportComponent,
            selector: 'rp-report-component',
            type: 'ObjectBaseComponent',
            label: 'Report Component'
        },
        {
            key: 'RpConfigPage',
            component: RpConfigPage,
            selector: 'mvs-rp-report-page',
            type: 'PageComponent',
            label: 'Report Config Page'
        },
        {
            key: 'RpReportPage',
            component: RpReportPage,
            selector: 'rp-report-page',
            type: 'PageComponent',
            label: 'Report Page'
        }
    ]
}

    export const RP_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: rpModuleEntry, multi: true }
];